import { ExecutionResult } from '@lcs/shared/api';
import { AccountInput, ExtensionInput, LocationInput, NullActionTypes } from 'generated/graphql-types';
import { AccountDetailSaveModel } from 'src/app/pages/account-details/models/account-detail-save.model';
import { SaveAccount } from 'src/app/pages/account-details/queries/generated/SaveAccount';
import { ExtensionDetailSaveModel } from 'src/app/pages/extension-details/models/extension-detail-save.model';

export function createAccountInput(
   account: AccountDetailSaveModel,
   accountFields: (keyof AccountInput)[]
): AccountInput {
   accountFields = [...accountFields, 'accountId'];

   const fields: string[] = accountFields;

   const accountInput: AccountInput = { accountId: account.accountId, fields };

   accountFields.forEach((field) => {
      accountInput[field.toString()] = account[field];
   });

   const accountLocationsFieldIndex = accountFields.indexOf('locations');
   if (accountLocationsFieldIndex !== -1) {
      accountFields.splice(accountLocationsFieldIndex, 1);
      formatEmbeddedLocationFields(accountFields, 'locations');

      const newLocationsInput: LocationInput[] =
         account.newAccountLocations?.map((location) => {
            return {
               fields: [],
               ...location,
               timeZoneId: location?.timeZoneId,
            };
         }) ?? [];
      accountInput.locations = newLocationsInput;
   }
   return accountInput;
}

export function createAccountAutoAttendantsInput(
   autoAttendants: ExtensionDetailSaveModel[] | undefined
): ExtensionInput[] {
   const autoAttendantFields: string[] = [
      'extensionId',
      'accountId',
      'name',
      'number',
      'type',
      'extensionAutoAttendant.timeoutSeconds',
   ];
   return (
      autoAttendants?.map((aa) => {
         return {
            fields: autoAttendantFields,
            name: aa.extension.name,
            number: aa.extension.number,
            type: aa.extension.type,
            extensionId: aa.extension.extensionId,
            accountId: aa.extension.accountId,
            extensionAutoAttendant: {
               timeoutSeconds: aa.extension.extensionAutoAttendant?.timeoutSeconds,
               timeoutNullAction: aa.extension.extensionAutoAttendant?.timeoutNullAction ?? NullActionTypes.Unset,
               fields: [],
            },
         };
      }) ?? []
   );
}

function formatEmbeddedLocationFields(fields: string[], key: string) {
   if (key) {
      fields.push(
         ...locationFields.map((keyField) => {
            return `${key}.${keyField}`;
         })
      );
   }
}

function formatEmbeddedExtensionFields(fields: string[], key: string) {
   if (key) {
      fields.push(
         ...addAccountExtensionFields.map((keyField) => {
            return `${key}.${keyField}`;
         })
      );
   }
}

export const locationFields: string[] = [
   'houseNumber',
   'name',
   'accountId',
   'directionalPrefix',
   'streetName',
   'streetNameSuffix',
   'directionalPostfix',
   'city',
   'state',
   'postalCode',
   'comment',
   'country',
   'timeZoneId',
];

export const addAccountExtensionFields: string[] = [
   'extensionId',
   'accountId',
   'name',
   'number',
   'type',
   'extensionAutoAttendant.timeoutSeconds',
   'extensionAutoAttendant.extensionId',
   'extensionHuntGroup.ringTimeout',
   'extensionHuntGroup.extensionId',
   'mailbox.emailAddress',
   'extensionMailbox.extensionId',
   'extensionFax.extensionId',
   'extensionFax.emailAddress',
   'extensionExternalForward.extensionId',
   'extensionExternalForward.forwardToNumber',
];

export type AccountSaveResult = ExecutionResult<SaveAccount>;
